"use client"
import "./css/productos.css"

// Importa los íconos de react-icons/gi
import { GiPig, GiCow, GiChicken, GiGoat } from "react-icons/gi"

// Solo importa las imágenes JPG (no los PDFs)
import portafolioCabrasImg from "../img/portafolio-cabras.jpg"
import portafolioGanaderiaImg from "../img/portafolio-ganaderia.jpg"
import portafolioPorcinoImg from "../img/portafolio-porcino.jpg"
import portafolioAvesImg from "../img/portafolio-aves.jpg"
import portafolioAvesImg2 from "../img/portafolio-aves2.jpg"
import portafolioAvesImg3 from "../img/portafolio-aves3.jpg"

const Productos = ({ onOpenImageModal }) => {
  const categories = [
    {
      id: "Aves",
      name: "Aves",
      IconComponent: GiChicken,
      imagePath: [portafolioAvesImg, portafolioAvesImg2, portafolioAvesImg3],
      title: "Portafolio Aves",
    },
    {
      id: "Ganado",
      name: "Ganado",
      IconComponent: GiCow,
      imagePath: portafolioGanaderiaImg,
      title: "Portafolio Ganadería",
    },
    {
      id: "Cerdos",
      name: "Cerdos",
      IconComponent: GiPig,
      imagePath: portafolioPorcinoImg,
      title: "Portafolio Porcino",
    },
    {
      id: "Climatización",
      name: "Cabras",
      IconComponent: GiGoat,
      imagePath: portafolioCabrasImg,
      title: "Portafolio Cabras",
    },
  ]

  const handleCategoryClick = (category) => {
    if (category.imagePath && category.title && onOpenImageModal) {
      // Siempre abrir imagen (tanto en móvil como en desktop)
      onOpenImageModal(category.imagePath, category.title)
    } else {
      console.log(`Categoría seleccionada: ${category.id}`)
    }
  }

  return (
    <section className="productos-container">
      <div className="productos-wrapper">
        <div className="categories-grid">
          {categories.map((category) => (
            <button key={category.id} className="category-item" onClick={() => handleCategoryClick(category)}>
              <category.IconComponent className="category-icon-lucide" />
              <div className="category-name">{category.name}</div>
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Productos
